import { z } from 'zod';
export const PlayerLeaderboardEntry = z.object({
    rank: z.number().int(),
    user_id: z.string(),
    username: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    active_frame_id: z.string().nullable(),
    current_tier: z.enum(['bronze', 'silver', 'gold', 'platinum', 'diamond']),
    score: z.number().int(),
    is_self: z.boolean(),
    is_friend: z.boolean(),
});
export const PlayerLeaderboardPrize = z.object({
    rank: z.number().int(),
    coins: z.number().int(),
    cosmetic_id: z.string().nullable(),
    cosmetic_name: z.string().nullable(),
});
export const PlayerLeaderboardViewRequest = z.object({
    game_id: z.string(),
});
export const PlayerLeaderboardViewResponse = z.object({
    game_id: z.string(),
    bracket_id: z.string(),
    week_starts_at: z.string(),
    resets_at: z.string(),
    bracket_size: z.number().int(),
    self_rank: z.number().int().nullable(),
    self_score: z.number().int(),
    entries: z.array(PlayerLeaderboardEntry),
    prizes: z.array(PlayerLeaderboardPrize),
    prize_cutoff_rank: z.number().int(),
});
export const PlayerLeaderboardHistoryRequest = z.object({
    game_id: z.string(),
    weeks: z.number().int().min(1).max(12).default(4),
});
export const PlayerLeaderboardHistoryRow = z.object({
    week_starts_at: z.string(),
    bracket_id: z.string(),
    rank: z.number().int(),
    score: z.number().int(),
    prize_coins: z.number().int(),
    prize_cosmetic_id: z.string().nullable(),
});
export const PlayerLeaderboardHistoryResponse = z.object({
    rows: z.array(PlayerLeaderboardHistoryRow),
});
//# sourceMappingURL=leaderboard.js.map